import { createTwStyle, joinCn } from '../util';
import type { VContextMenuProps } from './type';

const twStyle =
  createTwStyle<Omit<VContextMenuProps, keyof VContextMenuProps>>();

export default twStyle({
  container: joinCn(
    'fixed z-50',
    'p-scale/8',
    'w-[200px]',
    'bg-gray-600',
    'rounded-md',
    'text-body-md font-normal text-white',
    'shadow-sm',

    'focus:outline-none',
  ),

  divider: joinCn('h-px w-full bg-gray-500'),

  group: joinCn(''),

  item: joinCn(
    'px-scale/8 py-scale/4',
    'hover:bg-secondary-500 active:bg-secondary-600',
    'rounded-sm',
    'cursor-pointer',
    'select-none',
    'transition-colors',

    'aria-disabled:cursor-not-allowed aria-disabled:text-gray-500',
    'aria-disabled:hover:bg-inherit aria-disabled:active:bg-inherit',

    '**:aria-[label=v-context-menu-item-label]:flex-1',
    'aria-disabled:**:aria-[label=v-context-menu-item-shortcut]:text-body-sm **:aria-[label=v-context-menu-item-shortcut]:text-gray-300',
    '**:aria-[label=v-context-menu-item-shortcut]:capitalize',
    'aria-disabled:**:aria-[label=v-context-menu-item-shortcut]:text-gray-500',
  ),
});
